<template>
  <div>
      <body>
    <Mainlayout></Mainlayout>
    <div>
      <div
        style="background-size: cover; color: #fff; width: 100%"
        :style="{ backgroundImage: `url(${backgroundBanner})` }"
      >
        <br />
        <div>
          <div class="text-center" style="margin-top: 5%">
            <img
              class="text-center"
              src="../assets/img/icon/logoPickiddo.png"
              style="max-width: 100%"
            />
            <h1 class="custom-title-product text-center">PICKIDDO</h1>
            <h1 class="custom-title-product text-center">Education Platform</h1>
            <h2 class="display-5 text-center" style="font-weight: 500">
              <strong>A Solution for Students Management</strong>
            </h2>
            <br />
            <br />
            <CContainer>
              <h2 class="mb-5">Are you facing challenges in managing student records such as payments and attendance? 
                Our SaaS solution can simplify this for you. Request a demo now.</h2>
                <CButton type="button" class="custom-btn-login-active-signin mr-2" @click="GoToPlan()">Subscribe</CButton> <span class="mt-3"> | </span>
            <CButton type="button" class="custom-btn-login-active-signin ml-2" @click="GoToRegister()">Sign In</CButton>

           
            </CContainer>
            <div class="text-right" style="bottom: 0px">
            <img src="../assets/img/icon/phoneBanner.png" class="fixed" />
          </div>
          
          </div>
         
        </div>
      </div>
    </div>
    <div>
      <div class="text-center">
        <h2 class="header-34px mt-5">Introduction</h2>
        <CContainer>
          <h2 class="text-center" style="line-height: 1.5em">
            <strong class="text-warning"
              >Pickiddo Student Management Platform </strong
            >streamlines education administration and improves student
            experience. Features include enrollment, course management,
            attendance, grades, and more. User-friendly design, integrations,
            and strong security are provided. There are many institutions who
            have already made the switch.
          </h2>
        </CContainer>
      </div>
    </div>

    <div style="background: #000037">
      <CContainer>
        <CRow class="mt-5">
          <CCol sm="8">
            <CCol sm="12" class="mt-5">
              <CRow>
                <CCol sm="4">
                  <CCard class="p-2 mt-3">
                    <img src="../assets/img/icon/studentenroll.jpg" />
                    <div class="p-2">
                      <strong class="text-warning">Streamlined process</strong>
                      for
                      <strong class="text-warning">student enrollment </strong
                      >and management of student information.
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="4">
                  <CCard class="p-2">
                    <img src="../assets/img/icon/class.jpg" />
                    <div class="p-2">
                      <strong class="text-warning">
                        Ability to create and manage classes,</strong
                      >
                      assign teachers, and manage class schedules
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="4">
                  <CCard class="p-2 mt-3">
                    <img src="../assets/img/icon/realtime.jpg" />
                    <div class="p-2">
                      <strong class="text-warning"> Real-time tracking </strong
                      >of student attendance, with notifications for today's
                      classes.
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="4">
                  <CCard class="p-2 mt-3">
                    <img src="../assets/img/icon/reportcard.jpg" />
                    <div class="p-2">
                      <strong class="text-warning">
                        Organised report card </strong
                      >system and
                      <strong class="text-warning">centralised storage </strong
                      >of reports.
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="4">
                  <CCard class="p-2">
                    <img src="../assets/img/icon/workflow.jpg" />
                    <div class="p-2">
                      <strong class="text-warning"
                        >Integration with other tools</strong
                      >
                      and systems for a seamless workflow
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="4">
                  <CCard class="p-2 mt-3">
                    <img src="../assets/img/icon/interface.jpg" />
                    <div class="p-2">
                      Intuitive and user-friendly interface for both students
                      and educators.
                    </div>
                  </CCard>
                </CCol>
              </CRow>
            </CCol>
          </CCol>

          <CCol sm="4">
            <h3 class="header-34px mt-5 text-left text-white">
              Here are the key features of the Student Management Portal
            </h3>
            <CCard class="p-2">
              <img src="../assets/img/icon/mobile.jpg" />
              <div class="p-2">
                Available on
                <strong class="text-warning">Web and Mobile App</strong>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>

    <div
      style="background-size: cover; color: #fff; width: 100%"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div>
        <br />
        <br />
        <br />
        <CRow class="p-3">
          <CCol sm="4">
            <div id="overlay">
              <h1 class="custom-title-product text-left m-2">Dashboard</h1>
              <h3 class="text-warning ml-2">
                <strong>Dashboard overview</strong>
              </h3>
              <ul>
                <li>
                  <h4>
                    <strong class="text-warning"> Total Payments:</strong> View
                    and manage payments made by students
                  </h4>
                </li>
                <li>
                  <h4>
                    <strong class="text-warning"> TotalStudents: </strong>View
                    and manage student information
                  </h4>
                </li>
                <li>
                  <h4>
                    <strong class="text-warning"> Financial Summary:</strong>
                    Keep track of financial performance of the institution
                  </h4>
                </li>
                <li>
                  <h4>
                    <strong class="text-warning">
                      Total Record Attendance: </strong
                    >Easily record and track attendance
                  </h4>
                </li>
                <li>
                  <h4>
                    <strong class="text-warning"> Direct Access:</strong>
                    Streamlines administration
                  </h4>
                </li>
              </ul>
              <br /><br />
            </div>
          </CCol>
          <CCol sm="8">
            <img
              style="max-width: 100%"
              src="../assets/img/icon/dashboard1.png"
            />
          </CCol>
        </CRow>
      </div>
    </div>

    <div style="background: #000037">
      <div>
        <br />
        <br />
        <br />
        <CRow class="p-3">
          <CCol sm="7">
            <img style="max-width: 100%" src="../assets/img/icon/20.png" />
          </CCol>
          <CCol sm="5">
            <div>
              <br />
              <h1 class="custom-title-product text-left m-2 text-white">
                Record management
              </h1>
              <h3 class="text-warning ml-2">
                <strong>Student Record Management</strong>
              </h3>
              <ul class="text-white">
                <li>
                  <h4>Enroll new students</h4>
                </li>
                <li>
                  <h4>Manage student information</h4>
                </li>
                <li>
                  <h4>Attendance tracking</h4>
                </li>
                <li>
                  <h4>Report card organization</h4>
                </li>
                <li>
                  <h4>Secure storage of sensitive information</h4>
                </li>
              </ul>
            </div>
          </CCol>
        </CRow>
      </div>
    </div>

    <div
      style="background-size: cover; color: #fff; width: 100%"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div>
        <br />
        <br />
        <br />
        <CRow class="p-3">
          <CCol sm="4">
            <div id="overlay">
              <h1 class="custom-title-product text-left m-2">
                Student listing
              </h1>
              <h3 class="text-warning ml-2">
                <strong>Student Listing info</strong>
              </h3>
              <ul>
                <li>
                  <h4>Quick search for students</h4>
                </li>
                <li>
                  <h4>Display of important student information</h4>
                </li>
                <li>
                  <h4>Study plan management</h4>
                </li>
                <li>
                  <h4>Cost information</h4>
                </li>
                <li>
                  <h4>Status updates</h4>
                </li>
                <li>
                  <h4>
                    Option for customisable data columns for efficient viewing.
                  </h4>
                </li>
              </ul>
              <br /><br />
            </div>
          </CCol>
          <CCol sm="8">
            <img style="max-width: 100%" src="../assets/img/icon/21.png" />
          </CCol>
        </CRow>
      </div>
    </div>


    <div style="background: #000037">
      <div>
        <br />
        <br />
        <br />
        <CRow class="p-3">
          <CCol sm="7">
            <img style="max-width: 100%" src="../assets/img/icon/22.png" />
          </CCol>
          <CCol sm="5">
            <div>
              <br />
              <h1 class="custom-title-product text-left m-2 text-white">
                Schedule management
              </h1>
              <h3 class="text-warning ml-2">
                <strong>Schedule
Management Page</strong>
              </h3>
              <ul class="text-white">
                <li>
                  <h4>Color-coded time
table</h4>
                </li>
                <li>
                  <h4>Filter by teacher or
class</h4>
                </li>
                <li>
                  <h4>Detailed schedule
with exact times</h4>
                </li>
                <li>
                  <h4>Management of class
schedules</h4>
                </li>
                <li>
                  <h4>Easy visualization of
class schedules</h4>
                </li>
              </ul>
            </div>
          </CCol>
          <CCol sm="12">
                <h1 class="custom-title-product text-center m-2 text-white">
                Teacher & schedule management
              </h1>
              <div class="ml-5 mr-5">
              <img style="max-width: 100%" src="../assets/img/icon/23.png" />
            </div>

          </CCol>
        </CRow>
      </div>
    </div>


    <div
      style="background-size: cover; color: #fff; width: 100%"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div>
        <br />
        <br />
        <br />
        <CRow class="p-3">
          <CCol sm="12">
            <h1 class="custom-title-product text-center m-2 text-white">
                Easy to manage complex schedule
              </h1>
              <div class="ml-5 mr-5">
            <img style="max-width: 100%" src="../assets/img/icon/24.png" />
        </div>
          </CCol>
        </CRow>
      </div>
    </div>


    <div style="background: #000037">
      <div>
        <br />
        <br />
        <br />
        <CRow class="ml-5 mr-5">
          <CCol sm="6">
            <h1 class="custom-title-product text-left mt-5 ml-5 text-white">
                Subject or class <br /> management
              </h1>
          </CCol>
          <CCol sm="6">
            <div>
            
              <img style="max-width: 100%" src="../assets/img/icon/25.png" />
            
            </div>
          </CCol>
        </CRow>

        <CRow class="ml-5 mr-5">
            <CCol sm="6">
            <div>
            
              <img style="max-width: 100%" src="../assets/img/icon/26.png" />
            
            </div>
          </CCol>
          <CCol sm="6">
            <h1 class="custom-title-product text-left mt-5 ml-5 text-white">
                Student <br />management
              </h1>
          </CCol>
         
        </CRow>
      </div>
    </div>



    <div
      style="background-size: cover; color: #fff; width: 100%"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div>
        <br />
        <CRow class="p-3">
            <CCol sm="6">
                <div class="ml-3">
                 <div id="overlay">
                        <h1 class="custom-title-product text-left m-2 text-white">
                    Teacher management
                </h1>
                </div>
                <img style="max-width: 100%" src="../assets/img/icon/27.png" />

                <div id="overlay">
                        <h1 class="custom-title-product text-left m-2 text-white">
                            Attendance listing
                </h1>
                </div>
                <img style="max-width: 100%" src="../assets/img/icon/29.png" />

               
            </div>
              
            </CCol>
            <CCol sm="6">
                <br /><br /><br />
                <div id="overlay" class="mt-5">
                <h1 class="custom-title-product text-left m-2 text-white">
                    Record attendance management
                </h1>
                </div>
                <img style="max-width: 100%" src="../assets/img/icon/28.png" />

                <div id="overlay" class="mt-5">
                <h1 class="custom-title-product text-left m-2 text-white">
                    Broadcast message manual or automatically
                </h1>
                </div>
                <img style="max-width: 100%" src="../assets/img/icon/30.png" />

              
          
          </CCol>
        </CRow>
      </div>
    </div>



    <div style="background: #000037">
      <div>
        <br />
        <br />
        <br />
        <CRow class="ml-5 mr-5">
          <CCol sm="12">
            <h1 class="custom-title-product text-left mt-5 ml-5 text-white">
                Mobile App with teacher and parent interface
              </h1>
              <br />
              <img style="max-width: 100%" src="../assets/img/icon/31.png" />
          </CCol>

          <CCol sm="12">
            <h1 class="custom-title-product text-left mt-5 ml-5 text-white">
              </h1>
              <img style="max-width: 100%" src="../assets/img/icon/32.png" />
          </CCol>
          <CContainer>
            <h1 class="custom-title-product text-center m-2 text-white">
                <br /><br />
            Our solution streamlines the student management
process, providing a comprehensive and user-friendly
platform that simplifies administrative tasks and
enhances communication between teachers,
students, and parents
        </h1>
        </CContainer>
        </CRow>
      </div>
    </div>
    <Footerlayout></Footerlayout>
    </body>
  </div>
</template>

<script>
 
import Vue from "vue";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";
import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import backgroundBanner from "../assets/img/icon/galaxy.jpg";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  metaInfo: {
    title: 'Introduction Product - A Solution for Students Management',
    meta: [
      { property: 'og:title', content: 'Introduction Product - A Solution for Students Management' }
    ],
    link: [
        { rel: 'canonical', href: 'https://www.pickiddo.com/IntroProduct' }
      ]
  },
  name: "Login",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
      backgroundBanner,
    };
  },
  async mounted() {},
  computed: {

  },
  methods: {
    GoToRegister()
    {
      window.open("https://ctr.pickiddo.com/#/Login");
    },
    GoToPlan()
    {
      this.$router.push("PackageEduCenter");
    }
  },
};
</script>
<style scoped>
  
  .c-header {
  /* background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83; */

  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app{
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: 'Montserrat', sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: 'Montserrat';
font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}

.custom-title-product {
  margin: 0px;
  font-size: 3rem;
  line-height: 3.5rem;
  font-weight: 700;
  font-family: "Montserrat";
  padding-bottom: 24px;
}

div.fixed {
  position: relative;
  bottom: 0px;
  right: 0px;
}

#overlay {
  width: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
}
</style>